import React, { Fragment } from "react";
import { InputLabel, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ViewOnlyField from "components/Global/Fields/ViewOnlyField";

const styles = theme => ({
  group: {
    margin: `${theme.spacing.unit}px 0`
  },
  listItems: {
    color: "#000000;"
  },
  label:{
    fontWeight:"bold",
    color:"black"
  }
});

class GridRadioButtonList extends React.Component {
  createList = items => {
    const { classes } = this.props;
    return items.map(item => (
      <FormControlLabel
        disabled={!this.props.isEditing}
        key={item.label}
        control={<Radio />}
        className={classes.listItems}
        value={item.value}
        label={item.label}
      />
    ));
  };

  viewOnlyValue = (items, localValue) => {
    let val = localValue ? items.find(item => item.value === localValue).label : null;
    return val;
  }

  render() {
    let localValue =
      typeof this.props.value === "boolean"
        ? this.props.value.toString()
        : this.props.value;
    return (
      this.props.shouldShow && (
        <Fragment>
          <Grid item xs={3}>
            <InputLabel className={this.props.classes.label} htmlFor={this.props.name}>
              {this.props.label}
            </InputLabel>
          </Grid>
          <Grid item xs={4}>
          {!this.props.isEditing && 
             <ViewOnlyField value={this.viewOnlyValue(this.props.options, localValue)}/>
            }

          {this.props.isEditing && 
            <RadioGroup
              name={this.props.name}
              valueselected={localValue}
              value={localValue}
              onChange={this.props.onChange}
              row
            >
              {this.createList(this.props.options)}
            </RadioGroup>
          }
          </Grid>
        </Fragment>
      )
    );
  }
}

export default withStyles(styles)(GridRadioButtonList);
